import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { SalesTeam } from '@user/store/salesTeam'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback(
    (value: SalesTeam | null) => {
      setFieldValue(name, value?.id ?? '')
    },
    [setFieldValue, name],
  )

  return {
    handelChange,
  }
}
